import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
  dialogRoot: {
    color: '#32324D',
    borderRadius: '4px'
  },
  dialogTitleContainer: {
    background: '#F6F6F9',
    width: '100%',
    padding: '12px'
  },
  paginationContainer: {
    background: '#F2F9FF',
    color: '#32324D',

    '& .MuiSelect-icon': {
      color: '#32324D'
    },

    '& .MuiIconButton-root.Mui-disabled': {
      color: '#32324D',
      opacity: '0.44'
    }
  },
  dialogActionContainer: {
    background: '#F6F6F9'
  }
}));

export default useStyles;
